var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['hide-pass',!_vm.modelData.b[_vm.modelData.p]||'active'],on:{"click":function($event){$event.preventDefault();_vm.modelData.b[_vm.modelData.p] = !_vm.modelData.b[_vm.modelData.p]}}})}
var staticRenderFns = []

export { render, staticRenderFns }